"use strict";

var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstantText = exports.validateDecimalNumber = exports.validateNumber = void 0;
var react_1 = require("react");
var od_hooks_1 = require("@tencent/od-hooks");
var lodash_1 = __importDefault(require("lodash"));
var util_1 = require("./util");
/**
 * 校验是否为数字
 */
var validateNumber = function validateNumber(value) {
  var pass = false;
  var valueNumber = Number(value);
  if (lodash_1["default"].isNumber(valueNumber) && !lodash_1["default"].isNaN(valueNumber) && Number(valueNumber) >= 0) {
    pass = true;
  }
  return pass;
};
exports.validateNumber = validateNumber;
/**
 * 校验数字的小数个数
 */
var validateDecimalNumber = function validateDecimalNumber(value, decimalNumberMax) {
  var pass = false;
  var decimalNumber = value.includes('.') && value.replace(/\d+\.(\d*)/, '$1').length || 0;
  var valueNumber = Number(value);
  if (lodash_1["default"].isNumber(valueNumber) && !lodash_1["default"].isNaN(valueNumber) && decimalNumber <= decimalNumberMax) {
    pass = true;
  }
  return pass;
};
exports.validateDecimalNumber = validateDecimalNumber;
var useInstantText = function useInstantText(props) {
  var disabled = props.disabled,
    valueProps = props.value,
    errorProps = props.error,
    statusProps = props.status,
    maxLength = props.maxLength,
    maxLengthLabel = props.maxLengthLabel,
    _a = props.onlyNumber,
    onlyNumber = _a === void 0 ? false : _a,
    _b = props.onlyNumberLabel,
    onlyNumberLabel = _b === void 0 ? '请输入数字' : _b,
    _c = props.decimalNumber,
    decimalNumber = _c === void 0 ? 2 : _c,
    _d = props.decimalNumberLabel,
    decimalNumberLabel = _d === void 0 ? '仅支持 2 位小数' : _d,
    onChangeValue = props.onChangeValue,
    onChangeEditable = props.onChangeEditable,
    field = props.field,
    _e = props.notValidateBeforeClose,
    notValidateBeforeClose = _e === void 0 ? false : _e,
    _f = props.needInstantChangeInput,
    needInstantChangeInput = _f === void 0 ? false : _f,
    _g = props.needUpdateWithValueProps,
    needUpdateWithValueProps = _g === void 0 ? false : _g,
    _h = props.isNotFullWidthCharacter,
    isNotFullWidthCharacter = _h === void 0 ? false : _h;
  var inputRef = (0, react_1.useRef)(null);
  var formGroupRef = (0, react_1.useRef)(null);
  var _j = __read((0, od_hooks_1.useDimensions)(), 2),
    feedbackRef = _j[0],
    _k = _j[1].height,
    feedbackHeight = _k === void 0 ? 20 : _k;
  var _l = __read((0, react_1.useState)(false), 2),
    editable = _l[0],
    setEditable = _l[1];
  var _m = __read((0, react_1.useState)(valueProps || ''), 2),
    value = _m[0],
    setValue = _m[1];
  var _o = __read((0, react_1.useState)(errorProps || ''), 2),
    error = _o[0],
    setError = _o[1];
  var _p = __read((0, react_1.useState)(statusProps || 'normal'), 2),
    status = _p[0],
    setStatus = _p[1];
  var clickOutsideValidate = (0, react_1.useCallback)(function () {
    if (editable) {
      if (notValidateBeforeClose) {
        setEditable(false);
        onChangeEditable(false);
        onChangeValue(field, value);
      } else {
        if (value) {
          if (!error && status !== 'error') {
            // 不存在错误 并且 状态不是 error 才能关闭
            setEditable(false);
            onChangeEditable(false);
            onChangeValue(field, value);
          }
        } else {
          setError('不能为空');
          setStatus('error');
        }
      }
    }
  }, [editable, notValidateBeforeClose, onChangeEditable, onChangeValue, field, value, error, status]);
  (0, od_hooks_1.useClickOutside)(clickOutsideValidate, formGroupRef);
  (0, react_1.useEffect)(function () {
    var inputNode = inputRef.current;
    if (inputNode) {
      inputNode.focus();
    }
  }, [editable]);
  (0, react_1.useEffect)(function () {
    var len = isNotFullWidthCharacter ? value.length : (0, util_1.getFullWidthCharacterStrLength)(value);
    if (maxLength) {
      if (len > maxLength) {
        if (maxLengthLabel) {
          setError(maxLengthLabel);
        }
        setStatus('error');
      } else {
        if (maxLengthLabel) {
          setError('');
        }
        setStatus('normal');
      }
    } else {
      setError('');
      setStatus('normal');
    }
  }, [value.length, maxLength, maxLengthLabel, isNotFullWidthCharacter, value]);
  (0, react_1.useEffect)(function () {
    if (onlyNumber && !(0, exports.validateNumber)(value)) {
      setError(onlyNumberLabel);
      setStatus('error');
      return;
    }
    if (onlyNumber && !(0, exports.validateDecimalNumber)(value, decimalNumber)) {
      setError(decimalNumberLabel);
      setStatus('error');
    }
  }, [value, onlyNumber, onlyNumberLabel, decimalNumber, decimalNumberLabel]);
  (0, react_1.useEffect)(function () {
    if (error || status !== 'normal') {
      onChangeEditable(true);
    }
  }, [error, status, onChangeEditable]);
  (0, react_1.useEffect)(function () {
    if (needUpdateWithValueProps && !editable) {
      setValue(valueProps || '');
    }
  }, [needUpdateWithValueProps, valueProps, editable]);
  var handlePenClick = (0, react_1.useCallback)(function () {
    if (disabled) return;
    setEditable(true);
  }, [disabled]);
  var handleClear = (0, react_1.useCallback)(function () {
    setValue('');
    if (needInstantChangeInput) {
      onChangeValue(field, '');
    }
  }, [onChangeValue, field, needInstantChangeInput]);
  var handleInputChange = (0, react_1.useCallback)(function (e, val) {
    setValue(val);
    if (needInstantChangeInput) {
      onChangeValue(field, val);
    }
  }, [onChangeValue, field, needInstantChangeInput]);
  var handleKeyPress = (0, react_1.useCallback)(function (e) {
    // enter键处理
    if (e.charCode === 13) {
      setEditable(false);
    }
  }, []);
  var handleTextareaChange = (0, react_1.useCallback)(function (event) {
    var _a;
    setValue((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
  }, []);
  return {
    value: value,
    error: error,
    status: status,
    editable: editable,
    inputRef: inputRef,
    formGroupRef: formGroupRef,
    feedbackRef: feedbackRef,
    feedbackHeight: feedbackHeight,
    handlePenClick: handlePenClick,
    handleClear: handleClear,
    handleInputChange: handleInputChange,
    handleKeyPress: handleKeyPress,
    handleTextareaChange: handleTextareaChange,
    // export for test
    clickOutsideValidate: clickOutsideValidate
  };
};
exports.useInstantText = useInstantText;